
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining/[dining_id]",
      function () {
        return require("private-next-pages/dining/[dining_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining/[dining_id]"])
      });
    }
  